import { useSelector } from 'react-redux';
import * as EarningsService from 'services/sales/earnings';

export const useEarningsService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchEarnings = async (options = {}) => {
    const { error, payload } = await EarningsService.read({ ...options, token });
    if (error) {
      return { earnings: [], size: 0 };
    }

    const {
      data: earnings,
      meta: { size }
    } = payload;
    return { earnings: earnings || [], size };
  };

  return { fetchEarnings };
};
